import React from 'react';
import { commonRadioOptions } from '@utils/commons';
import { AdvanceDecisonType } from '../../../utils';

interface HasAdvanceDecisionProps {
  advanceDecision: AdvanceDecisonType;
  setAdvanceDecision: React.Dispatch<React.SetStateAction<AdvanceDecisonType>>;
}

const HasAdvanceDecision: React.FC<HasAdvanceDecisionProps> = ({
  advanceDecision,
  setAdvanceDecision,
}) => {
  return (
    <div className="mt-7 govuk-bp:mt-11">
      <h1 className="govuk-heading-l">
        Advance decision to Refuse Treatment (ADRT)
      </h1>
      <div className="govuk-body">
        A record of an advance decision to refuse one or more specific types of
        future treatment, made by a person who had capacity at the time of
        recording the decision. The decision only applies when the person no
        longer has the capacity to consent to or refuse the specific treatment
        being considered. An ADRT must be in writing, signed and witnessed. If
        the ADRT is refusing life-sustaining treatment it must state
        specifically that the treatment is refused even if the person’s life is
        at risk.
      </div>
      <div className="govuk-form-group mt-10 govuk-bp:mt-14">
        <fieldset className="govuk-fieldset">
          <legend className="govuk-fieldset__legend govuk-fieldset__legend--l">
            <h1 className="govuk-fieldset__heading">
              Has an Advance Decision to Refuse Treatment been completed?
            </h1>
          </legend>
          <div className="govuk-radios" data-module="govuk-radios">
            {commonRadioOptions.map(option => (
              <div className="govuk-radios__item" key={option.value}>
                <input
                  className="govuk-radios__input"
                  id="has-advance-decision"
                  name="hasAdvanceDecision"
                  type="radio"
                  value={option.value}
                  checked={advanceDecision.status === option.value}
                  onChange={() => {
                    setAdvanceDecision(prev => ({
                      ...prev,
                      status: option.value,
                    }));
                  }}
                />
                <label
                  className="govuk-label govuk-radios__label"
                  htmlFor={option.value}
                >
                  {option.label}
                </label>
              </div>
            ))}
          </div>
        </fieldset>
      </div>
    </div>
  );
};

export default HasAdvanceDecision;
